import { t as e } from "../../utils-DiFe-_ei.js";
import { t } from "../../search-Chd7o8f1.js";
import { Dialog as n, DialogContent as r, DialogDescription as i, DialogTitle as a } from "../../foundations/dialog.js";
import "../../dialog-DGSJCBAd.js";
import { Typography as o } from "../../foundations/typography.js";
import "../../typography-CTPDhvds.js";
import { t as s } from "../../Avatar-DPnco3PK.js";
import { useState as c } from "react";
import { Fragment as l, jsx as u, jsxs as d } from "react/jsx-runtime";
//#region src/components/media/AvatarLabel/AvatarLabel.tsx
var f = {
	xs: "gap-2",
	sm: "gap-2.5",
	md: "gap-3"
};
function p({ name: t, subtitle: n, size: r = "sm", shape: i = "circle", avatar: a, trailing: c, inactive: l = !1, children: p, className: m }) {
	return /* @__PURE__ */ d("span", {
		className: e("flex min-w-0 items-center", f[r], m),
		children: [
			/* @__PURE__ */ u("span", {
				className: e("flex shrink-0", l && "grayscale"),
				children: a ?? /* @__PURE__ */ u(s, {
					name: t,
					size: r,
					shape: i
				})
			}),
			/* @__PURE__ */ d("span", {
				className: "flex min-w-0 flex-1 flex-col gap-1.5",
				children: [/* @__PURE__ */ d("span", {
					className: "flex min-w-0 flex-col leading-tight",
					children: [/* @__PURE__ */ u(o, {
						as: "span",
						variant: r === "xs" ? "body-sm" : "body",
						color: l ? "muted" : void 0,
						truncate: !0,
						className: "font-medium",
						children: t
					}), n && /* @__PURE__ */ u(o, {
						as: "span",
						variant: "label",
						color: "muted",
						truncate: !0,
						className: "font-normal",
						children: n
					})]
				}), p]
			}),
			c && /* @__PURE__ */ u("span", {
				className: "flex shrink-0 items-center",
				children: c
			})
		]
	});
}
//#endregion
//#region src/components/media/IconBadge/IconBadge.tsx
var m = {
	soft: {
		neutral: "bg-muted text-muted-foreground",
		sky: "bg-sky-50 text-sky-700 dark:bg-sky-950/50 dark:text-sky-300",
		blue: "bg-blue-50 text-blue-600 dark:bg-blue-950/50 dark:text-blue-300",
		green: "bg-green-50 text-green-600 dark:bg-green-950/50 dark:text-green-300",
		amber: "bg-amber-50 text-amber-700 dark:bg-amber-950/50 dark:text-amber-300",
		rose: "bg-rose-50 text-rose-600 dark:bg-rose-950/50 dark:text-rose-300",
		red: "bg-red-50 text-red-600 dark:bg-red-950/50 dark:text-red-300",
		violet: "bg-violet-50 text-violet-600 dark:bg-violet-950/50 dark:text-violet-300"
	},
	solid: {
		neutral: "bg-foreground text-background",
		sky: "bg-sky-500 text-white",
		blue: "bg-blue-500 text-white",
		green: "bg-green-600 text-white",
		amber: "bg-amber-500 text-white",
		rose: "bg-rose-500 text-white",
		red: "bg-red-600 text-white",
		violet: "bg-violet-500 text-white"
	},
	outline: {
		neutral: "bg-background border-muted-foreground text-muted-foreground",
		sky: "bg-background border-sky-500 text-sky-500",
		blue: "bg-background border-blue-500 text-blue-500",
		green: "bg-background border-green-600 text-green-600",
		amber: "bg-background border-amber-500 text-amber-500",
		rose: "bg-background border-rose-500 text-rose-500",
		red: "bg-background border-red-600 text-red-600",
		violet: "bg-background border-violet-500 text-violet-500"
	}
}, h = {
	xs: {
		root: "size-5",
		icon: "size-2.5",
		outline: "border-[1.5px]"
	},
	sm: {
		root: "size-6",
		icon: "size-3",
		outline: "border-2"
	},
	md: {
		root: "size-7",
		icon: "size-3.5",
		outline: "border-2"
	},
	lg: {
		root: "size-10",
		icon: "size-5",
		outline: "border-2"
	}
}, g = {
	xs: {
		root: "-top-1 -right-1 size-2.5",
		icon: "size-1.5"
	},
	sm: {
		root: "-top-1 -right-1 size-3",
		icon: "size-2"
	},
	md: {
		root: "-top-1.5 -right-1.5 size-3.5",
		icon: "size-2"
	},
	lg: {
		root: "-top-1.5 -right-1.5 size-4",
		icon: "size-2.5"
	}
};
function _({ icon: t, tone: n = "neutral", variant: r = "soft", size: i = "sm", cornerBadge: a, label: o, className: s }) {
	let c = h[i], l = r !== "soft";
	return /* @__PURE__ */ d("span", {
		className: e("relative inline-flex shrink-0 items-center justify-center rounded-full", c.root, r === "outline" && c.outline, m[r][n], s),
		...o ? {
			role: "img",
			"aria-label": o
		} : { "aria-hidden": !0 },
		children: [/* @__PURE__ */ u(t, {
			className: c.icon,
			strokeWidth: l ? 2.5 : 2,
			"aria-hidden": "true"
		}), a && /* @__PURE__ */ u("span", {
			className: e("border-background absolute flex items-center justify-center rounded-full border", g[i].root, m.solid[a.tone]),
			children: /* @__PURE__ */ u(a.icon, {
				className: g[i].icon,
				strokeWidth: 3,
				"aria-hidden": "true"
			})
		})]
	});
}
//#endregion
//#region src/components/media/ImageLightbox/ImageLightbox.tsx
function v({ src: o, alt: s, title: f, className: p, fullWidth: m }) {
	let [h, g] = c(!1);
	return /* @__PURE__ */ d(l, { children: [/* @__PURE__ */ d("button", {
		type: "button",
		"aria-label": `View ${s} full size`,
		onClick: () => g(!0),
		className: e("group relative cursor-zoom-in", m ? "block w-full" : "inline-block"),
		children: [/* @__PURE__ */ u("img", {
			src: o,
			alt: s,
			className: e(p)
		}), /* @__PURE__ */ u("span", {
			className: "absolute inset-0 flex items-center justify-center rounded-md bg-black/0 transition-colors group-hover:bg-black/30",
			children: /* @__PURE__ */ u("span", {
				className: "bg-background/90 flex size-8 items-center justify-center rounded-full opacity-90 shadow-sm transition-opacity group-hover:opacity-100",
				children: /* @__PURE__ */ u(t, {
					className: "text-foreground size-4",
					"aria-hidden": "true"
				})
			})
		})]
	}), /* @__PURE__ */ u(n, {
		open: h,
		onOpenChange: g,
		children: /* @__PURE__ */ d(r, {
			className: "max-w-3xl p-2",
			children: [
				/* @__PURE__ */ u(a, {
					className: "sr-only",
					children: f ?? s
				}),
				/* @__PURE__ */ d(i, {
					className: "sr-only",
					children: ["Full-size preview of ", s]
				}),
				/* @__PURE__ */ u("img", {
					src: o,
					alt: s,
					className: "max-h-[80vh] w-full rounded-md object-contain"
				})
			]
		})
	})] });
}
//#endregion
export { s as Avatar, p as AvatarLabel, _ as IconBadge, v as ImageLightbox };

//# sourceMappingURL=index.js.map